import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';
import { FreeSpins } from 'react-easyrocket';

export const FreeSpinsContext = createContext<{
  oldFreeSpins?: FreeSpins;
  saveFreeSpins?: (freeSpins: FreeSpins) => void;
  freeSpinsChanged?: boolean;
  setFreeSpinsChanged?: Dispatch<SetStateAction<boolean>>;
}>({});

const FREESPINS_LS_KEY = 'oldFreeSpin';

export const useIniFreeSpins = () => {
  const [oldFreeSpins, setOldFreeSpins] = useState<FreeSpins>();
  const [freeSpinsChanged, setFreeSpinsChanged] = useState<boolean>(false);

  const saveFreeSpins = (freeSpins: FreeSpins) => {
    const fsFromStorage = localStorage.getItem(FREESPINS_LS_KEY);
    setOldFreeSpins(freeSpins);
    localStorage.setItem(FREESPINS_LS_KEY, `${freeSpins?.number}`);

    if (Number(fsFromStorage) < freeSpins?.number) {
      setFreeSpinsChanged(true);
    }
  };
  return { oldFreeSpins, saveFreeSpins, freeSpinsChanged, setFreeSpinsChanged };
};

export const useFreeSpins = () => {
  return useContext(FreeSpinsContext);
};
